import RegisterRouter from './register-router';

export default RegisterRouter;
